import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Icon, notification } from "antd";
import axios from "axios";
import moment from "moment";

import ExcelTabelaRelatorios from "./_Aux/ExcelTabelaRelatorios";
import ExcelTabelaRelatoriosSAT from "./_Aux/ExcelTabelaRelatoriosSAT";
import ModalViewer from "../../shared/components/Modals/ModalViewer";
import ModalLoading from "../../shared/components/Modals/ModalLoading";
import ModalHorarioRelatorio from "./_Aux/ModalHorarioRelatorio";
import ModalHorarioRelatorioMaravilha from "./_Aux/ModalHorarioRelatorioMaravilha";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class ListaRelatorioNotas extends Component {
    state = {
        disciplinaId: localStorage.getItem("vista") === "TURMA" ? null : localStorage.getItem("codigo_curso"),
        periodoId: 0,
        isSat: false,
        //LOADING
        visibleLoading: false,
        //VIEWER
        visibleViewer: false,
        isModalVisible: false,
        startDate: undefined,
        endDate: undefined,
        docs: [],
        dates: [],
        empresaId: localStorage.getItem("entidade_id")
    };

    componentDidMount() {
        this.verificarSAT();
    }

    exportarPdf = (disciplina, startDate, endDate, dataEmissao, isCompleto) => {
        if (this.state.disciplinaId > 0 && this.state.empresaId == 3) {
            disciplina = this.state.disciplinaId;
        }

        this.getMeses();
        this.setState(
            {
                visibleLoading: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/pdf/exportar-notas",
                    params: {
                        cursoId: disciplina,
                        dataEmissao: moment(dataEmissao).format("DD/MM/YYYY"),
                        dt_inicio: moment(startDate).format("YYYY/MM/DD"),
                        dt_fim: moment(endDate).format("YYYY/MM/DD"),
                        isCompleto: isCompleto
                    }
                })
                    .then(response => {
                        let fileName = `${localStorage.getItem("header_codigo")} ${localStorage.getItem("header_nome")}`;
                        if (localStorage.getItem("disciplina_nome")) fileName = localStorage.getItem("disciplina_nome");

                        this.setState({
                            visibleLoading: false,
                            visibleViewer: true,
                            docs: [{ uri: response.data, fileName }]
                        });
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                        this.setState({
                            visibleLoading: false
                        });
                    });
            }
        );
    };

    getMeses = () => {
        axios({
            method: "get",
            url: "/api/aulas-exportar/get-meses",
            params: {
                id: this.state.disciplinaId,
                periodoId: this.state.periodoId
            }
        })
            .then(response => {
                this.setState({
                    dates: response.data.map(e => e.dataHora)
                });
            })
            .catch(() => {});
    };

    verificarSAT = () => {
        axios({
            method: "get",
            url: "/api/aulas-exportar/verificar-sat",
            params: {
                id: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                this.setState({
                    isSat: response.data
                });
            })
            .catch(() => {});
    };

    toggleModal = () => {
        this.getMeses();
        this.setState(prevState => ({
            isModalVisible: !prevState.isModalVisible
        }));
    };

    render() {
        const {
            //LOADING
            visibleLoading,
            isSat,
            //VIEWER
            visibleViewer,
            docs,
            dates,
            empresaId
        } = this.state;

        return (
            <>
                <div className="container container-body">
                    <div className="bloco-curso-diario-opcoes" style={{ gap: 10 }}>
                        <h3 className="titulo-bloco">{localStorage.getItem("entidade_id") === "33" ? "Médias" : "Resultados"}</h3>
                        <div className="bloco-opcoes-esquerda">
                            <Link className={`botao-icon-detalhe botao-maior`} to="#" title="Visualizar" onClick={this.toggleModal}>
                                <Icon type="eye" />
                            </Link>
                            <Link
                                to={`/gerir-detalhe-turma/${this.props.match.params.turma}/${
                                    localStorage.getItem("vista") === "TURMA" ? "horario" : "horario-disciplina"
                                }`}
                                className="botao-secundario botao-secundario-redondo"
                                title="Voltar"
                                style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                            >
                                <Icon type="arrow-left" />
                            </Link>
                        </div>
                    </div>
                    <div className="curso-diario">
                        {empresaId == 33 && isSat ? (
                            <>
                                <ExcelTabelaRelatoriosSAT
                                    carregarPeriodoId={periodoId => this.setState({ periodoId })}
                                    setDisciplinaId={disciplinaId => this.setState({ disciplinaId })}
                                />
                            </>
                        ) : (
                            <ExcelTabelaRelatorios
                                carregarPeriodoId={periodoId => this.setState({ periodoId })}
                                setDisciplinaId={disciplinaId => this.setState({ disciplinaId })}
                            />
                        )}
                    </div>
                </div>
                <ModalLoading visible={visibleLoading} text="A gerar documento..." />
                <ModalViewer visible={visibleViewer} docs={docs} onCancel={() => this.setState({ visibleViewer: false })} />
                {empresaId == 3 || (empresaId == 33 && isSat) ? (
                    <>
                        <ModalHorarioRelatorioMaravilha
                            datas={dates}
                            disciplina={this.state.disciplinaId}
                            visible={this.state.isModalVisible}
                            onClose={this.toggleModal}
                            onSelect={(option3, dataEmissao) => {
                                this.exportarPdf(option3, dataEmissao);
                            }}
                        />
                    </>
                ) : (
                    <ModalHorarioRelatorio
                        datas={dates}
                        disciplina={this.state.disciplinaId}
                        visible={this.state.isModalVisible}
                        onClose={this.toggleModal}
                        onSelect={(option3, dataEmissao, option2, tipo, isCompleto) => {
                            this.setState({
                                startDate: option2.start_date,
                                endDate: option2.end_date
                            });
                            this.exportarPdf(option3, option2.start_date, option2.end_date, dataEmissao, isCompleto);
                        }}
                    />
                )}
            </>
        );
    }
}

export default ListaRelatorioNotas;
